import style from './transparencia.module.scss';

export default function Transparencia() {
  return (
    <div className={style.section}>
      <h2 className={style.title}>Relatório de Transparência e Igualdade Salarial de Mulheres e Homens</h2>
      <div className={style.content}>
        <p>
          Este é o relatório de transparência salarial, elaborado e disponibilizado pelo Ministério do Trabalho e Emprego, que dispõe sobre a
          igualdade salarial e de critérios remuneratórios entre homens e mulheres.
        </p>
        <a
          href='https://portal-bucket.azureedge.net/wp-content/2024/03/Relatorio_da_transparencia.pdf'
          target='_blank'
          rel='noopener noreferrer'>
          <button
            className={style.button}
            type='button'>
            Acessar o Relatório
          </button>
        </a>
        <p style={{}}>Fonte: eSocial. Rais 2022 e Portal Emprega Brasil (março de 2024)</p>
      </div>
    </div>
  );
}
